import * as React from "react";
import { styled } from "../../ui/theme";
import FullGraph from "./FullGraph";
import useComponentSize from "../../hook/useComponentSize";
import { useStore } from "../../App";
import { observer } from "mobx-react";

export default observer(function Chart() {
  const ref = React.useRef<HTMLDivElement>(null);
  const size = useComponentSize(ref);
  const store = useStore();

  return (
    <Container ref={ref}>
      <FullGraph
        width={size.width > 0 ? size.width : 100}
        height={size.height > 0 ? size.height : 100}
        data={store.days.map(day => ({
          id: day.index,
          date: day.date,
          name: day.label,
          total: day.total,
          delta: day.delta,
          deaths: day.deaths,
          ic: day.ic,
          infected: day.infected
        }))}
        activeIndex={store.activeIndex}
      />
    </Container>
  );
});

const Container = styled.div`
  flex-grow: 1;
  overflow: hidden;
  max-width: 100%;
`;
